import React from "react";
import { Paper, CardContent, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    margin: "2em",
    backgroundColor: "#EEF2F4",
    height: "20.5em",
    width: "26em",
    textAlign: "center",
    borderRadius: "0.3em",
  },
  content: {
    width: "18.5em",
    height: "6.5em",
    margin: "0 auto",
    marginTop: "3em",
  },
  header: {
    marginBottom: "1.3em",
  },
}));

const ServiceBox = ({ header, paragraph }) => {
  const classes = useStyles();
  return (
    <Paper data-testid="serviceBox" className={classes.paper}>
      <CardContent className={classes.content}>
        <Typography className={classes.header} color="primary" variant="h3">
          {header}
        </Typography>
        <Typography color="secondary" variant="subtitle1">
          {paragraph}
        </Typography>
      </CardContent>
    </Paper>
  );
};

export default ServiceBox;
